function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  id: "Facebook__x28_alt_x29_",
  d: "M90,15.001C90,7.119,82.884,0,75,0H15C7.116,0,0,7.119,0,15.001v59.998   C0,82.881,7.116,90,15.001,90H45V56H34V41h11v-5.844C45,25.077,52.568,16,61.875,16H74v15H61.875C60.548,31,59,32.611,59,35.024V41   h15v15H59v34h16c7.884,0,15-7.119,15-15.001V15.001z",
  fill: "#FFFFFF"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "34px",
    height: "50px",
    viewBox: "0 0 90 90",
    style: {
      "enableBackground": "new 0 0 90 90"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/facebook.06924502.svg";
export { SvgComponent as ReactComponent };